module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-29-eccdc49b81ab59afd7f59694ef48c75f.jpg";